<app-img-header-mobile
  title="Cotizador de Distribuidores"
  alt="Daimler Truck"
  image="/assets/images/cotizador/intro.jpg"
  [contentTemplate]="template"
>
</app-img-header-mobile>
<app-preloader *ngIf="isLoading"></app-preloader>
<app-notifications></app-notifications>
<main class="main" id="">
  <div id="detail">
    <div class="pageWidth">
      <div class="actionsWrapper">
        <button
          class="tertiary"
          [routerLink]="['/quote/standard-quote/new-quote']"
        >
          <i class="icon"></i> Nueva cotización
        </button>
      </div>
      <!-- <button (click)="notificationTest()">Notificacion error</button>
      <button (click)="notificationTestSuccess()">Notificacion success</button> -->

      <div *ngIf="!hasData" class="noData">No hay información disponible</div>
      <div *ngIf="hasData" class="customListMobile listadoCotizacionesEstandarMobile">
        @for (quote of data; track getRowKey(quote.id, $index)) {
          <div
            class="row"
            [tp]="quote.invalidFor"
            [ngClass]="{ obsolete: !!quote.invalidFor }"
          >
            <div class="general">
              <div class="wrapper">
                <div class="numero">
                  {{ quote.id }}
                </div>
                <div class="cliente">
                  <span>
                    {{ showCustomerName(quote.customer) }}
                  </span>
                </div>
              </div>
              <div class="wrapper">
                <!-- Incluir clase "borrador", "enProgreso", "completo"-->
                <div class="tag" [ngClass]="getStatusCssClass(quote.status)">
                  {{ getStatus(quote.status) }}
                </div>
                <!-- Incluir la clase "active" cuando se está mostrando el menú-->
                <div
                  class="contextualMenuMobile"
                  [ngClass]="{
                    active: isMenuRowOpen(getRowKey(quote.id, $index)),
                  }"
                >
                  <a
                    class="toggle"
                    aria-haspopup="menu"
                    aria-controls="menu-id"
                    role="button"
                    [attr.aria-expanded]="!!openRowOption()"
                    [id]="getMobileMenuTriggerId(getRowKey(quote.id, $index))"
                    (click)="
                      toggleMobileMenuOptions(
                        $event,
                        getRowKey(quote.id, $index)
                      )
                    "
                    >Ver/Ocultar menu</a
                  >
                  <div
                    class="menuContent"
                    role="menu"
                    id="menu-id"
                    appBackdropOverlay
                    appOutSideClick
                    [isActive]="!!openRowOption()"
                    [ignoreElements]="[
                      getMobileMenuTriggerId(getRowKey(quote.id, $index)),
                    ]"
                    [activeTarget]="openRowOption()"
                    [currentTarget]="getRowKey(quote.id, $index)"
                    (outSideClick)="closeMobileMenuOptions()"
                    style="z-index: 40"
                  >
                    <ul>
                      @if (userId != quote.creationUser) {
                        <li role="menuitem">
                          <a
                            class="iconAndText view"
                            [routerLink]="[
                              '/standard-quote/edit-quote/' + quote.id,
                            ]"
                            >Ver</a
                          >
                        </li>
                        <li role="menuitem">
                          <a
                            class="iconAndText duplicate"
                            (click)="openModalToDuplicateStandardQuote(quote)"
                            >Duplicar</a
                          >
                        </li>
                      } @else if (quote.linkedToCreditRequest) {
                        <li role="menuitem">
                          <a
                            class="iconAndText view"
                            [routerLink]="[
                              '/standard-quote/edit-quote/' + quote.id,
                            ]"
                            >Ver</a
                          >
                        </li>
                        <li role="menuitem">
                          <a
                            class="iconAndText duplicate"
                            (click)="openModalToDuplicateStandardQuote(quote)"
                            >Duplicar</a
                          >
                        </li>
                      } @else if (quoteIsTerminalCustomerOnly(quote)) {
                        <li role="menuitem">
                          <a
                            class="iconAndText edit edit-client-only"
                            tp="Editar cliente"
                            [routerLink]="[
                              '/standard-quote/edit-quote/' + quote.id,
                            ]"
                            >Editar cliente</a
                          >
                        </li>
                        <li role="menuitem">
                          <a
                            class="iconAndText duplicate"
                            (click)="openModalToDuplicateStandardQuote(quote)"
                            >Duplicar</a
                          >
                        </li>
                      } @else {
                        @if (quote.invalidFor) {
                          <li role="menuitem">
                            <a
                              class="iconAndText edit"
                              [routerLink]="[
                                '/standard-quote/edit-quote/' + quote.id,
                              ]"
                            >
                              Editar
                            </a>
                          </li>
                        } @else {
                          <li role="menuitem">
                            <a
                              class="iconAndText edit"
                              [routerLink]="[
                                '/standard-quote/edit-quote/' + quote.id,
                              ]"
                            >
                              Editar
                            </a>
                          </li>
                          <li role="menuitem">
                            <a
                              class="iconAndText duplicate"
                              (click)="openModalToDuplicateStandardQuote(quote)"
                              >Duplicar</a
                            >
                          </li>
                        }
                        <li
                          role="menuitem"
                          *ngIf="userId == quote.creationUser"
                        >
                          <a
                            class="iconAndText delete"
                            (click)="openModalConfirmation(quote)"
                            >Eliminar</a
                          >
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="title">
              <div class="cotizacion">
                <span>
                  {{ quote.quoteName }}
                </span>
              </div>
              <div class="propuestas">
                {{ quote.dealAmount }}
                <span
                  >Propuesta<span *ngIf="quote.dealAmount > 1">s</span></span
                >
              </div>
            </div>

            <div class="data">
              <div class="fa">
                <span>Total FA</span>
                <b>{{ formatInputValue(quote.faTotal) }}</b>
              </div>
              <div class="propietario">
                @if (quote.userName && quote.userName?.length > 21) {
                  <span>
                    {{ quote.userName }}
                  </span>
                } @else {
                  <span>Propietario</span>
                  {{ quote.userName }}
                }
              </div>
              <div class="edicion">
                <span>Última edición</span>
                {{ format(quote.updatedDate, true) }}
              </div>
            </div>
          </div>
        }
      </div>

      <div *ngIf="hasData">
        <app-paginator
          [total]="total"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (changePage)="handlePage($event)"
        ></app-paginator>
      </div>

      <button
        class="tertiary"
        [routerLink]="['/quote/standard-quote/new-quote']"
      >
        <i class="icon"></i> Nueva cotización
      </button>
    </div>
  </div>
</main>
<ng-template #template>
  <div>
    <label>Nombre de la cotización</label>
    <app-input
      [data]="searchNameQuote"
      (textSearch)="filter($event, 'quoteName')"
      [resetInput]="reset"
    ></app-input>
  </div>
  <div>
    <label>Nombre del cliente</label>
    <!-- <app-input
        [data]="searchNameCustomer"
        (textSearch)="filter($event, 'customerName')"
        [resetInput]="reset"
      ></app-input> -->
    <app-input-api-search
      [endpoint]="getAllClientsUrl()"
      searchKey="customerName"
      labelKey="customerName"
      placeholder="Buscar cliente"
      httpMethod="POST"
      [additionalParams]="readonlyAdditionalSearchClientParams"
      (searchSelected)="handleSearchClient($event)"
      [resetInput]="reset"
    ></app-input-api-search>
  </div>

  <app-date-picker
    [isRange]="true"
    label="Fecha de creación"
    placeholderFrom="Desde"
    placeholderTo="Hasta"
    [selectedDateFrom]="params.filter.from"
    [selectedDateTo]="params.filter.to"
    (selectedDateFromChange)="filter($event, 'from')"
    (selectedDateToChange)="filter($event, 'to')"
  ></app-date-picker>
  @if (showThirdPartyQuotesFilter) {
    <div>
      <label class="checkboxWrapper myQuotation" for="myQuotation">
        <input
          type="checkbox"
          id="myQuotation"
          [(ngModel)]="params.filter.me"
          (ngModelChange)="filter($event, 'me')"
        />
        <span class="checkmark"></span>
        <span class="description">Mis cotizaciones</span>
      </label>
    </div>
  }
  <div *ngIf="showQuoteValidityListFilter">
    <label>Vigencia</label>
    <app-select
      [options]="validStatusFilter.data"
      [placeholder]="validStatusFilter.placeholder"
      [defaultValue]="params.filter.validStatus"
      (optionSelected)="filter($event, 'validStatus')"
      [resetSelect]="reset"
    ></app-select>
  </div>

  <div class="filtersActions">
    <button class="primary" (click)="search()">Buscar</button>
    <button class="secondary" (click)="resetFilters()">Limpiar filtros</button>
  </div>
</ng-template>
<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="deleteQuoteById()"
  ></app-template-confirmation>
</ng-template>

<ng-template #templateDuplicateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="duplicateQuoteById()"
  ></app-template-confirmation>
</ng-template>
